import React, { Component } from 'react';
import { connect } from 'react-redux';

import Messages from '../components/Messages';
import ScriptBar from '../components/ScriptBar';
import {emojify} from 'react-emojione';
import {RadioGroup, Radio} from 'react-radio-group'
import AlertContainer from 'react-alert'
import { sendMessage, setAlert} from '../actions';

const mapStateToProps = (state) => {
    return ({
        alert: state.convo.meta.alert,
        user: state.user,
        convoCode: state.convo.meta.convoCode
    });
}

class ChatUI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            emotion: ''
        }
        
        this.emojis = [":heart_eyes:", ":)", ":neutral_face:", ":slight_frown:", ":angry:"];
        this.msg = null;
        this.textAlert = "Please type a valid response";
        this.emojiAlert = "Please choose an emotion";
        this.alertOptions = {
            offset: 14,
            position: 'top left',
            theme: 'dark',
            time: 10000,
            transition: 'scale'
        };
    
        this.handleContent = this.handleContent.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.handleSelectedEmotion = this.handleSelectedEmotion.bind(this);
    }

    handleContent(event) {
        this.setState({ content: event.target.value });
    }

    handleSend(event) {
        if (this.msg != null) {
            this.msg.show(this.props.alert, {
                time: 5000,
                type: 'success',
                icon: null
            })    
        } else {
            // Send message
            this.props.dispatch(this.sendMessage(this.input.value, this.state.emotion));

            // Clear input
            this.input = "";                

        }
    }
    
    handleSelectedEmotion(value) {
        this.setState({ emotion: value });
    }

    // componentDidMount() {
    //     this.scrollToBottom(false);
    // }

    // componentDidUpdate() {
    //     this.scrollToBottom();
    // }

    // onScrollViewLayout = (event) => {
    //     const layout = event.nativeEvent.layout;

    //     this.setState({
    //         scrollViewHeight: layout.height
    //     });
    // }

    // onInputLayout = (event) => {
    //     const layout = event.nativeEvent.layout;

    //     this.setState({
    //         inputHeight: layout.height
    //     });
    // }

    // scrollToBottom(animate = true) {
    //     const { scrollViewHeight, inputHeight } = this.state,
    //           { chatHeight } = this.props;

    //     const scrollTo = chatHeight - scrollViewHeight + inputHeight;

    //     if (scrollTo > 0) {
    //        this.refs.scroll.scrollToPosition(0, scrollTo, animate)
    //     }
    // }

    // _scrollToInput(reactRef) {
    //     this.refs.scroll.scrollToFocusedInput(ReactNative.findNodeHandle(reactRef));
    // }


    sendMessage = (text, emotion) => {

        if (text == '') {
            return setAlert(this.textAlert);
        } else if (emotion == '') {
            return setAlert(this.emojiAlert);
        } else {
            return sendMessage(this.props.convoCode, text, this.props.user, emotion)
        }
    }

    render() {
        let alert = <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />;
        if (this.props.alert == '') {
            alert = null
        }

        return (
            <div>
                <h2>Welcome to the chatpool, {this.props.user.name}!</h2>
                <Messages />
                <ScriptBar />
                <h3>Type your message here:</h3>
                <input type="text" name="content" value={this.state.content} ref={(el) => this.input = el} onChange={this.handleContent} placeholder="Say something..."/>
                <h3>Before you send your message, choose the emoji representing the emotion you are feeling</h3>
                <RadioGroup name="emotionsRadioGroup" selectedValue={this.state.emotion} onChange={this.handleSelectedEmotion}>
                {
                    this.emojis.map((emoji, index) => 
                        <label key={index}>
                            <Radio value={emoji}/>{emojify(emoji)}
                        </label>
                    )
                }
                </RadioGroup>
                {alert}

                <button onClick={this.handleSend}>Send message</button>
            </div>
        )
    }
}

export default connect(mapStateToProps)(ChatUI);


// WEBPACK FOOTER //
// ./src/components/ChatUI.js